export const GOAL_DATE_PROPERTY = 'date';
export const GOAL_VALUE_PROPERTY = 'value';
export const DATETIME_GOAL = 'datetime.goal';